// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d6f90f87","703":"78310ce0"}[chunkId] + ".chunk.js";
};